export default {
    summer: 'Summer',
    winter: 'Winter',
};
